import { useEffect } from 'react';

function SistemaRedirectScreen() {
    useEffect(() => {
        window.location.replace('https://www.unisind.com.br/sismov')
    }, [])
}

export default SistemaRedirectScreen;